import DatasetItem from "components/Organisms/DatasetsMenu/DatabaseDropdown/DropdownChildren/DatasetItem";
import NotFoundText from "components/Atoms/NotFoundText";
import LoadingText from "components/Atoms/LoadingText";

import { useDatasets } from "hooks/datasets/useDatasets";
import { maybeMissing } from "utils/data/validate";
import { memo, useMemo } from "react";

interface DropdownChildrenProps {
  open?: boolean;
  databaseId: string;
}

const DropdownChildren = memo(({ open, databaseId }: DropdownChildrenProps) => {
  const contentClass = useMemo(
    () => (open ? "max-h-screen" : "max-h-0"),
    [open]
  );

  const datasets = useDatasets(databaseId);
  const items = useMemo(() => datasets?.res, [datasets]);

  if (datasets?.loading) return <LoadingText subject="Datasets" />;
  if (!items?.length) return <NotFoundText subject="Datasets" />;

  return (
    <div className={`flex flex-col overflow-auto ${contentClass}`}>
      {items?.map(({ name, id }) => {
        return (
          <DatasetItem
            displayName={maybeMissing(name)}
            id={maybeMissing(id)}
            key={id}
          />
        );
      })}
    </div>
  );
});

export default DropdownChildren;
